export default __webpack_public_path__ + "static/floor3-slide-5-7bb58403744cda3426398d7e6b43f494.jpg";